import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { useQuery } from "@tanstack/react-query";
import { Path2Container, RepoContainer } from "../components/Container";
import { AddFilesModal, LoaderModal, RemoveFileModal, RenameFileModal } from "../components/Modal";
import { FileApi } from "../app/api/file.api";
import { getFilePreview } from "../app/utilis/filePreview";


export function RepositoryDoc()
{
    const file = FileApi();

    const {repid, folderid}  = useParams();

    const fetchDocuments = async () => {
        const {data} = await file.findAllByFolder(folderid);
        console.log(data)
        return data.data;
    };
         
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["allDocuments"],
        queryFn: fetchDocuments,
    });


    const [ modalState , setModalState ] = useState(false);
    const closeModal = ( arg ) => {  setModalState( arg ) }    
    const setModal = () => setModalState(true);

    const [status, setStatus] = useState(0);
    const [ loadingStatus , setLoadingStatus ] = useState(false);
    const [ isShown , setIsShown ] = useState(false);
    const closeModal2 = ( arg ) => {  setIsShown( arg ) } 


    const [ curFileId , setcurFileId ] = useState();
    const [ curFileName , setcurFileName ] = useState();

    const [renameModal, setRenameModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const openRenameModal = (fileId, fileName) => {
        setRenameModal(true);
        setcurFileId(fileId);
        setcurFileName(fileName);
    } 

    const openDeleteModal = (fileId) => {
        setDeleteModal(true);
        setcurFileId(fileId);
    } 

    const closeRenameModal = ( arg ) => {  setRenameModal( arg ) }  

    return(

        <div className="container-fluid">
            {
               modalState && ( <AddFilesModal refetch={ refetch } method={ closeModal } folderId={ folderid } setLoadingStatus={ setLoadingStatus } setIsShown={setIsShown} setStatus={setStatus} /> ) 
            }
            {
                isShown && ( <LoaderModal close={ closeModal2 } isLoading={ loadingStatus } status={status} /> )
            }
            {
                renameModal && ( <RenameFileModal refetch={ refetch } close={ closeRenameModal } fileId={ curFileId } name={ curFileName } /> )
            }
            {
                deleteModal && ( <RemoveFileModal refetch={ refetch } close={ setDeleteModal } fileId={ curFileId } /> )
            }
            <div className="row"> 
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom"> <NavBarThree target={'panel'} />  </div>
                {/* ************************************************* */}
                <div className="col-md-12">  
                    <div className="row min-vh-100">  
                        {/* ----------------------------------------------------------------------- */}
                        <div className="col-lg-3 px-4 pt-4 pb-5 bg-light border-bottom ">
                             <div className="row">
                                <div className="col-md-12"> 
                                    <RepoContainer />  
                                </div>
                                <div className="col-md-12">
                                    <div className="border d-flex flex-column rounded-2 mt-4">
                                        <span className="p-3 border-bottom text-secondary"> Nouveau répertoire</span>
                                        <div  className="p-3 text-muted"> 
                                            <a href="/nouveau-repertoire" className="btn btn-green btn-sml"> 
                                              Ajouter <i className="bi bi-arrow-right ms-1"></i>
                                            </a> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ------------------------------------------------------------------------- */}
                        <div className="col-lg-9 border-start border-bottom bg-light pb-4">
                            <div className="row gap-3 d-flex align-items-center justify-content-between border-bottom mb-3 py-4">
                                <Path2Container repId={repid} folderId={folderid} />
                                <div className="col-sm-3">
                                   <button className="btn btn-sm btn-green" onClick={ setModal }> 
                                      Uploader <i className="bi bi-plus-circle ms-1"></i>
                                   </button>
                                </div>   
                            </div>

                            <div className="row px-4 py-2">
                                {   
                                    (isLoading) ? ( 
                                         <div className="col-lg-12 d-flex justify-content-center p-4" >  
                                            <div className="placeholder" style={{ height:'200px' }}></div>
                                         </div> ) : null 
                                }                                                  
                                {
                                     ( Array.isArray(data) && data.length > 0  ) ?    
                                     ( data.map( (item, index )=> (
                                                                                
                                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 rounded">
                                            <div className="border">
                                                <div className="d-flex flex-column align-items-center" key={index}>
                                                    <div className="d-flex justify-content-center gap-2 mb-3 border-bottom p-2 w-100">
                                                        <a href={ item?.path } download className="font-xs text-secondary link cursor border px-2 py-1" title="Télécharger" >  
                                                            <i class="bi bi-download"></i>
                                                        </a>
                                                        <span className="font-xs text-secondary cursor border px-2 py-1" title="Renommer" onClick={ ()=> openRenameModal(item?.id, item?.name) } >  
                                                            <i class="bi bi-pencil-square"></i>
                                                        </span>
                                                        <span className="font-xs text-secondary cursor border px-2 py-1" title="Supprimer" onClick={ ()=> openDeleteModal(item?.id) } >  
                                                            <i class="bi bi-trash"></i>
                                                        </span>
                                                    </div>
                                                    <a href={ item?.path } target="blank" className="d-flex flex-column link text-secondary" >
                                                        <img
                                                            src={getFilePreview(item?.path)}
                                                            alt={item?.name}
                                                            style={{ width: "120px", height: "120px", objectFit: "contain" }}
                                                        />
                                                        <span className="text-secondary font-sm text-center mt-2"> { item?.name } </span>
                                                     </a>
                                                </div>
                                            </div>
                                        </div>
                                
                                    ))
                                    ) : (  ( Array.isArray(data) && data.length === 0  ) ?
                                        ( 
                                            <div className="d-flex justify-content-center pt-5"> 
                                                <div className="col-lg-5 col-md-8 border p-5 d-flex justify-content-center align-items-center lead text-secondary">  
                                                   Liste de fichiers vide 
                                                </div>
                                            </div> 
                                        ) : null 
                                    )
                                }                                     
                                {   
                                    (error) ? ( 
                                           <div className="row d-flex justify-content-center pt-5"> 
                                            <div className="col-lg-5 col-md-8 border p-5 d-flex justify-content-center align-items-center lead text-secondary">  
                                               Erreur serveur interne  
                                            </div>
                                        </div> 
                                    ) : null  
                                } 

                            </div>
                        </div>
                        {/* ------------------------------------------------------------------------- */}
                    </div>     
                </div> 
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
            </div>
        </div>  

    )
}



